import React from 'react'

import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const UnsavedCalendarEventPopup = (props) => {
  const cancelButtonRef = useRef(null)

  const discardUnsavedChanged = () => {
      if(props.discardType === 'new-event') {
          //set new event to false
          props.setOpenEvent(false)
          props.setNewEvent(false)
          props.setOpen(false)
      } else if (props.discardType === 'existing-event') {
          props.setEditEventToggle(false)
          props.setOpen(false)
      } else if (props.discardType === 'new-offer') {
        props.setOpen(false)
        props.setOpenOffer(false)
      }
  }

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={props.setOpen}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enterTo="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0 sm:scale-100" leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:w-72 sm:p-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-base font-medium leading-6 m-0 my-2 text-gray-900">
                      Discard unsaved changes?
                    </Dialog.Title>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button type="button" className="inline-flex w-full justify-center rounded-md border border-transparent px-2 py-1 text-base font-bold cursor-pointer text-red-600 bg-white focus:outline-none sm:ml-3 sm:w-auto sm:text-sm" onClick={() => discardUnsavedChanged()}>
                    Discard
                  </button>
                  <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md border-none bg-white px-2 py-1 text-base cursor-pointer font-bold text-gray-500 focus:outline-none focus:ring-none focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm" onClick={() => props.setOpen(false)} ref={cancelButtonRef}>
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default UnsavedCalendarEventPopup